import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const required = () => {
  return 'Required';
};
const AcceptError = ({ nonEdit, editClickError }) => (
  <Content>
    {({ someDetailsNotCompleted }) => (
      <Field name="AcceptError" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="AcceptError"
            title=""
            validationMessage={!nonEdit && editClickError ? someDetailsNotCompleted : ''}
          >
            <Field
              name="AcceptError"
              type="input"
              validate={!nonEdit && editClickError ? required : undefined}
            >
              {() => <div></div>}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default AcceptError;
